import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { SubscriptionObject } from 'app/shared/models/standard.models';
import { SharedDataService } from 'app/shared/services/shared-data.service';
import { DAWA, DAWASearch } from 'app/shared/utilities/dawa';
import { Subscription } from 'rxjs';

@Component({
  selector: 'jublo-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.css']
})
export class AddressComponent implements OnInit, OnDestroy, OnChanges {

  @Input() address: string;
  @Input() zip: string;
  @Input() city: string;
  @Input('options') o: any;
  @Output() addressChange = new EventEmitter<string>();
  @Output() zipChange = new EventEmitter<string>();
  @Output() cityChange = new EventEmitter<string>();

  companyLanguage: string = 'da-DK';
  searching: boolean = false;
  dawa = new DAWASearch(this.http);
  dawaResults: DAWA[] = [];
  highlightIndex:number = 0;
  options = new AddressOptions();
  resultsMaxHeight:number = (15 * 6) // 6rem min height
  positionAbove: boolean = true;
  result
  subscriptions: SubscriptionObject = {};

  constructor(private http: HttpClient, private shared: SharedDataService) { }

  ngOnInit(): void {
    this.subscriptions['language'] = this.shared.companyInformation().subscribe({
        next:(data) => this.companyLanguage = data.companyLanguage
      })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(!!changes.o && !!changes.o.currentValue){
      for(let x of Object.keys(this.o)){
        this.options[x] = this.o[x]
      }
    }
    if(!!changes.zip && !!changes.zip.currentValue && !!changes.zip.previousValue){
      if(this.companyLanguage == 'da-DK'){
        this.dawa.address(this.address, this.zip).subscribe({next:(data)=> {
          if(!data || !data.length){
            this.address = null;
            this.addressChange.emit(null)
          }
        }})
      }
    }
  }

  ngOnDestroy(): void {
    for(let x of Object.keys(this.subscriptions)) this.subscriptions[x].unsubscribe();
  }

  search(search: KeyboardEvent){
    if(this.companyLanguage == 'da-DK'){
      if( (search.key == 'Enter' || search.code == 'Enter') && this.dawaResults && this.dawaResults.length) {

      }
      else if(!!(search.target! as HTMLInputElement).value && (search.target! as HTMLInputElement).value.length > 2){
        this.searching = true;
        this.dawa.address((search.target! as HTMLInputElement).value, this.zip).subscribe((data:DAWA[]) => {
          this.dawaResults = data;
          if(!!this.options.scrollParent) this.adjustResultsHeight(search.target as HTMLElement)
        })
      }
    }
    else {
      this.addressChange.emit((search.target! as HTMLInputElement).value)
    }
  }

  adjustResultsHeight(input: HTMLElement) {
    var scrollParent = input.closest(this.options.scrollParent) as HTMLElement; // Find the closest scroll parent
    if(!!scrollParent) {
      var scrollParentHeight = scrollParent.offsetHeight; // Get the height of scroll parent
      var inputPosition = input.getBoundingClientRect().top - scrollParent.getBoundingClientRect().top; // Get position of input within scroll parent
      var results = input.nextSibling; // Get the search results element
      var positionAbove = (inputPosition > scrollParentHeight / 2); // Check if input is below the center of scroll parent
      var maxHeight = positionAbove ? inputPosition : scrollParentHeight - inputPosition - input.offsetHeight; // Calculate max height of results
      this.resultsMaxHeight = Math.max(maxHeight, (15 * 6)); // Ensure a minimum height of 6rem
    }
}

  pickAddress(clickedAddress){
    let a = this.addressWithoutZipCity(clickedAddress.tekst, clickedAddress.adresse.postnr, clickedAddress.adresse.postnrnavn);
    this.address = a;
    this.addressChange.emit( a );
    this.zipChange.emit(clickedAddress.adresse.postnr);
    this.cityChange.emit(clickedAddress.adresse.postnrnavn);
  }

  doneSearching(){
    setTimeout(()=> {
      this.searching = false;
      this.addressChange.emit(this.address)
    } , 200)
  }

  addressWithoutZipCity(address:string, zip:string, city:string){
    let s = `, ${zip} ${city}`;
    return address.replace(s, '')
  }

  addressEntered(ev: Event){
    ev.preventDefault();
  }

}

class AddressOptions {
  classes: string = 'form-control borderless';
  defaultRelative: boolean = true;
  zIndex:number = 20;
  scrollParent: string = '.modal-body';
}
